import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const PlotlineDiscardIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z" />
    </SvgIcon>
  )
}
export default PlotlineDiscardIcon
